export default __webpack_public_path__ + "static/media/misc005.1a6ac957.jpeg";